import React, { useState } from 'react';
import { Dropdown, Icon } from 'antd';
import CheckMarkMenu from '../../../../../../../../components/CheckMarkMenu/CheckMarkMenu';
import DispexButton from '../../../../../../../../components/DispexButton/DispexButton';
import styles from './index.module.scss';

const SelectField = ({ items, selectedItems, btnText, onChange }) => {
  const [dropdownVisible, setDropdownVisible] = useState(false);

  const handleMenuClick = (item) => {
    onChange(item);
    setDropdownVisible(false);
  };

  const handleVisibleChange = (visible) => {
    setDropdownVisible(visible);
  };

  return (
    <Dropdown
      trigger={['click']}
      visible={dropdownVisible}
      onVisibleChange={handleVisibleChange}
      placement="bottomRight"
      overlay={
        <CheckMarkMenu
          items={items}
          selectedItems={selectedItems}
          renderContent={(item) => item.name}
          visible={dropdownVisible}
          handlers={{
            onMenuClick: handleMenuClick,
          }}
        />
      }
    >
      <DispexButton type="primary" className={styles.button}>
        {btnText}
        <Icon type={dropdownVisible ? 'caret-up' : 'caret-down'} />
      </DispexButton>
    </Dropdown>
  );
};

export default SelectField;
